import { getRequestsExtraInfo } from '../../../../api'
import { createSearchArray } from '../../../../utils/api'
import { getItemsIds } from '../../../../utils/common'

export function getExtraItemIds(items) {
  return items && getItemsIds(items).join(',')
}

export function loadExtra(items) {
  if (items) {
    const params = createSearchArray('id', items)

    if (Array.from(params).length > 0) {
      return getRequestsExtraInfo(params).then(({ data }) => data)
    }
  }
}
